export const SYSTEM_CHECK_PATH = "/settings-menu/system-check";
